var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.022 7.856-.128-.176a2.567 2.567 0 0 0-.792-.648 2.727 2.727 0 0 0-1.352-.352H2.79c-.48 0-.936.12-1.352.352-.312.168-.592.4-.824.688a2.828 2.828 0 0 0-.6 2.024L.31 13.48C.414 14.608.55 16 3.086 16h9.376c2.536 0 2.664-1.392 2.776-2.528l.296-3.72a2.692 2.692 0 0 0-.512-1.896zm-5.336 4.416H5.854a.562.562 0 0 1-.56-.56c0-.304.248-.56.56-.56h3.832c.312 0 .56.256.56.56 0 .312-.248.56-.56.56zM14.622 5.277c.03.306-.302.511-.594.414a3.983 3.983 0 0 0-1.271-.203H2.789a4.07 4.07 0 0 0-1.293.21c-.289.096-.619-.102-.619-.406V3.728C.877.872 1.749 0 4.605 0h.944c1.144 0 1.504.368 1.968.968l.96 1.28c.2.272.208.288.56.288h1.904c2.5 0 3.478.67 3.68 2.741z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFile);
export default __webpack_public_path__ + "static/media/open_file.07e1da01854dd8f397a0ca9b0433850b.svg";
export { ForwardRef as ReactComponent };